import { logInfo } from '@betty/toolkit/logging';
import { BottomSheet, navigationRef } from '@betty/navigation';
import {
  socketConnected,
  startListening,
  verifyIdentity,
  depositApproved as appDepositApproved,
} from '@betty/toolkit/state';
import { selectAccountStatus } from '@betty/account/state';
import { DepositApprovedEventData } from './deposit.types';
import { depositApproved, openDeposit } from './deposit.slice';

startListening({
  actionCreator: openDeposit,
  effect: (_, { dispatch, getState }) => {
    const accountStatus = selectAccountStatus(getState());

    if (accountStatus === 'Timeout') {
      BottomSheet.open({
        namespace: 'common',
        type: 'InfoImage',
        data: {
          image: 'common.rejected',
          titleNS: 'common',
          titleKey: 'errorTitle',
          descriptionNS: 'wallet',
          descriptionKey: 'depositUserOnBreak',
        },
      });

      return;
    }

    if (accountStatus !== 'Approved') {
      dispatch(verifyIdentity());

      return;
    }

    navigationRef.navigate('Deposit');
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on('DepositApproved', (data: DepositApprovedEventData) => {
      logInfo('GenericHub', 'DepositApproved', data);

      if (!data) return;

      const currentRouteName = navigationRef.current?.getCurrentRoute()?.name;

      if (
        currentRouteName !== 'PaymentStatusScreen' &&
        currentRouteName !== 'DepositLaunchScreen'
      ) {
        BottomSheet.open({
          namespace: 'wallet',
          type: 'DepositCompleted',
          singleton: false,
          data: {
            amount: data.amount,
          },
        });
      }

      dispatch(depositApproved(data));
    });
  },
});

startListening({
  actionCreator: depositApproved,
  effect: (_, { dispatch }) => {
    dispatch(appDepositApproved());
  },
})
